import type {CourseExpandedCommon} from '../../../api/course';

type CourseDisplaySource = Pick<
  CourseExpandedCommon,
  'current_offer_id' | 'currentOffer' | 'edition'
>;

/**
 * Unified display source for course fields after extend.
 * If course has current_offer_id, values should come from current offer.
 */
export const getCourseDisplayFields = (course: CourseDisplaySource) => {
  const {current_offer_id, currentOffer, edition} = course;
  const hasCurrentOffer = Boolean(current_offer_id && currentOffer);

  return {
    clientConferences: hasCurrentOffer
      ? currentOffer!.client_conferences
      : edition?.client_conferences,
    duration: hasCurrentOffer ? currentOffer!.duration : edition?.duration,
    paymentPlan: hasCurrentOffer
      ? currentOffer!.type === 'personal'
        ? currentOffer!.payment_plan
        : null
      : (edition?.payment_plan ?? null),
  };
};
